import WeapiEventPayload from './contracts/weapiEventPayload';

const sendBeacon = (url: string, payload: WeapiEventPayload) => {
  const headers = {
    // Hack for sendBeacon to work. Should be 'application/json'.
    type: 'text/plain',
  };

  const data = {
    query: `mutation weapiEvent($EventPayload: EventPayload!) { event( payload: $EventPayload ) }`,
    operationName: 'weapiEvent',
    variables: { EventPayload: payload },
  };

  if (navigator.sendBeacon) {
    const blob = new Blob([JSON.stringify(data)], headers);
    // Note: this will return a 400 if any of the required fields aren't present, such as BCID or Carvana user ID.
    navigator.sendBeacon(url, blob);
  } else {
    fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
      keepalive: true,
    })
      .then(response => {
        console.log('Clickstream event sent successfully', response.text);
      })
      .catch(error => {
        throw Error(`Error: ${error}`);
      });
  }
};

export default sendBeacon;
